import React, { Component, ReactNode } from "react";
import { DirtyPageContext, IDirtyPageContext } from "./DirtyPageContext";

export interface IDirtyPageProviderProps
{
    children?: ReactNode;
}

interface IDirtyPageProviderState
{
    dirtyPages: Record<string, boolean>;
}

export class DirtyPageProvider extends Component<
    IDirtyPageProviderProps,
    IDirtyPageProviderState
> {
    public state: IDirtyPageProviderState = {
        dirtyPages: {},
    };

    private readonly setPageDirty = (pageKey: string, isDirty: boolean): void =>
    {
        this.setState((prevState) =>
        {
            const next = { ...prevState.dirtyPages };

            if (isDirty)
            {
                next[pageKey] = true;
            }
else
{
                delete next[pageKey];
            }

            return { dirtyPages: next };
        });
    };

    private get contextValue(): IDirtyPageContext
    {
        return {
            isAnyPageDirty: Object.keys(this.state.dirtyPages).length > 0,
            setPageDirty: this.setPageDirty,
        };
    }

    public render(): ReactNode
    {
        return (
            <DirtyPageContext.Provider value={this.contextValue}>
                {this.props.children}
            </DirtyPageContext.Provider>
        );
    }
}

export default DirtyPageProvider;
